import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import NavPage from "../../components/nav-page/NavPage";
export const _frontmatter = {
  "title": "Komponenter",
  "rank": 1
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <nav {...{
      "className": "table-of-contents"
    }}><ol parentName="nav" {...{
        "className": "toc-level toc-level-1"
      }}></ol></nav>
    <NavPage {...props} mdxType="NavPage" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      